import React from 'react';

export const EmptyChatIcon: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='136'
    height='137'
    fill='none'
    viewBox='0 0 136 137'
  >
    <path
      fill='var(--stroke)'
      fillRule='evenodd'
      d='M105.506 93.623l2.883-4.133c4.52-6.477 7.111-14.091 7.111-22.24C115.5 44.277 94.62 25 68 25S20.5 44.277 20.5 67.25 41.38 109.5 68 109.5c3.339 0 6.592-.306 9.73-.887l1.67-.31 33.986 5.869-7.88-20.55zm12.832 31.044l-38.879-6.713A62.95 62.95 0 0168 119c-30.83 0-57-22.552-57-51.75C11 38.05 37.17 15.5 68 15.5s57 22.551 57 51.75c0 10.22-3.263 19.712-8.82 27.676l8.436 21.999a5.793 5.793 0 01-.904 5.716 5.671 5.671 0 01-5.374 2.026z'
      clipRule='evenodd'
    ></path>
  </svg>
);
